import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";

import { BranchOffices } from '../../models/admin-models/branch-offices.model';
import { Filter } from '../../models/filter.model';

@Injectable({
    providedIn: 'root'
})
export class BranchOfficeService {

    constructor(private httpClient: HttpClient) { }

    getOne(id: Number) {
        return this.httpClient.get('api/branchoffices/' + id).toPromise();
    }

    gridView(filter: Filter) {
        return this.httpClient.post('api/branchoffices/gridview', filter.data)
            .pipe(
                map((res: any) => {
                    return res;
                }),
                catchError((error) => {
                    return throwError(error);
                })
            )
    }

    boxView() {
        return this.httpClient.get('api/branchoffices/boxview')
            .pipe(
                map((res: any) => {
                    return res;
                }),
                catchError((error) => {
                    return throwError(error);
                })
            )
    }

    createBranchOffice(lookup: BranchOffices) {
        return this.httpClient.post('api/branchoffices/create', lookup.data).toPromise();
    }

    editBranchOffice(lookup: BranchOffices) {
        return this.httpClient.post('api/branchoffices/edit', lookup.data).toPromise();
    }

    deleteBranchOffice(ids: Array<Number>) {
        return this.httpClient.post('api/branchoffices/delete', ids).toPromise();
    }

}